import * as React from 'react';
import { DialogStateContext } from './dialog-state';
export var useDialogController = function () {
    var _a = React.useContext(DialogStateContext), openedDialogs = _a.openedDialogs, close = _a.close;
    var closeAllDialogs = function () {
        openedDialogs.forEach(function (dialogId) { return close(dialogId); });
    };
    return [closeAllDialogs];
};
//# sourceMappingURL=use-dialog-controller.js.map